import { render, staticRenderFns } from "./PromotionsCard.vue?vue&type=template&id=26c38cfc&scoped=true"
import script from "./PromotionsCard.vue?vue&type=script&lang=js"
export * from "./PromotionsCard.vue?vue&type=script&lang=js"
import style0 from "./PromotionsCard.vue?vue&type=style&index=0&id=26c38cfc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26c38cfc",
  null
  
)

export default component.exports